import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Button, Modal } from "react-bootstrap";
import { ButtonLoader } from "Components";
import { newAuthService } from "Service/Axios";
import { createRulesFolderUrl, updateRulesFolderUrl } from "Constant/api";
import { Validator } from "Utils/validator";

export const CreateFolder = ({ show, toggle, folderData, fetchList }) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    folderName: "",
    folderDescription: "",
  });
  const [errMsg, setErrMsg] = useState({
    folderName: "",
    folderDescription: "",
  });

  const { folderName, folderDescription } = formData;

  useEffect(() => {
    if (folderData) {
      setFormData({
        folderName: folderData.name,
        folderDescription: folderData.description,
      });
    }
  }, [folderData]);

  // On Change
  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    if (e.target.name === "folderName") {
      if (!Validator.text(e.target.value)) {
        setErrMsg((prev) => ({
          ...prev,
          folderName: t("common.messages.error.common.folderName.blank"),
        }));
      } else {
        setErrMsg((prev) => ({
          ...prev,
          folderName: "",
        }));
      }
    }

    if (e.target.name === "folderDescription") {
      if (!Validator.text(e.target.value)) {
        setErrMsg((prev) => ({
          ...prev,
          folderDescription: t(
            "common.messages.error.common.folderDescription.blank"
          ),
        }));
      } else {
        setErrMsg((prev) => ({
          ...prev,
          folderDescription: "",
        }));
      }
    }
  };

  const getValidation = () => {
    return new Promise((resolve) => {
      if (Validator.text(folderName) && Validator.text(folderDescription)) {
        resolve(true);
      } else {
        if (folderName && !Validator.text(folderName)) {
          setErrMsg((prev) => ({
            ...prev,
            folderName: t("common.messages.error.common.folderName.blank"),
          }));
        }

        if (folderDescription && !Validator.text(folderDescription)) {
          setErrMsg((prev) => ({
            ...prev,
            folderDescription: t(
              "common.messages.error.common.folderDescription.blank"
            ),
          }));
        }

        resolve(false);
      }
    });
  };

  // On Submit
  const onSaveFolder = async () => {
    const validationStatus = await getValidation();
    if (validationStatus) {
      setLoading(true);
      try {
        const payload = {
          name: folderName,
          description: folderDescription,
        };
        if (folderData) {
          payload.gid = folderData.gid;
        }
        const response = await newAuthService(
          folderData ? updateRulesFolderUrl : createRulesFolderUrl,
          "POST",
          payload
        );
        if (response && response.status && response.data.success) {
          if (
            response.message ===
            "The folder is already exist. Please try another name."
          ) {
            toast.error(
              t("common.messages.notification.failed.duplicateFolder")
            );
          } else {
            toast.success(
              t(
                `common.messages.notification.success.${
                  folderData ? "updateFolder" : "createFolder"
                }`
              )
            );
            fetchList();
            toggle();
          }
        } else {
          toast.error(response.data.message);
        }
      } catch {
        toast.error(
          t("common.messages.notification.failed.somethingWentWrong`")
        );
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <Modal
      show={show}
      onHide={toggle}
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header className="justify-content-center">
        <Modal.Title>
          {t(`auth.rules.${folderData ? "editFolder" : "createFolder"}`)}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-4">
          <label className="form-label" htmlFor="folderName">
            {t("common.label.folder")}
          </label>
          <input
            type="text"
            className="form-control"
            id="folderName"
            placeholder={t("common.placeHolder.folderName")}
            name="folderName"
            value={folderName}
            onChange={handleChange}
          />
          {errMsg.folderName && <p className="error">{errMsg.folderName}</p>}
        </div>
        <div className="mb-4">
          <label className="form-label" htmlFor="folderDescription">
            {t("common.label.description")}
          </label>
          <textarea
            type="text"
            className="form-control"
            rows={2}
            id="folderDescription"
            placeholder={t("common.placeHolder.folderDescription")}
            name="folderDescription"
            value={folderDescription}
            onChange={handleChange}
          />
          {errMsg.folderDescription && (
            <p className="error">{errMsg.folderDescription}</p>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={toggle}>
          {t("common.button.cancel")}
        </Button>
        {!loading ? (
          <Button variant="primary" onClick={onSaveFolder}>
            {t("common.button.save")}
          </Button>
        ) : (
          <ButtonLoader />
        )}
      </Modal.Footer>
    </Modal>
  );
};
